import { Component, OnInit } from '@angular/core';
import { HttpQueriesService } from '../Services/http-queries.service';

@Component({
  selector: 'app-congres-virtuel-change-pass',
  templateUrl: './congres-virtuel-change-pass.component.html',
  styleUrls: ['./congres-virtuel-change-pass.component.scss']
})
export class CongresVirtuelChangePassComponent implements OnInit {

  int = 1;
  data = {email:null, code:null, pass:null, confirm_pass:null};
  sending = false;

  constructor(private httpservice:HttpQueriesService) { }

  ngOnInit() {
  }

  sendEmail(){
    this.sending = true;
    this.httpservice.vcSendMailToChangePass({email:this.data.email}).subscribe(v=>{
      this.sending = false;
      this.int = 2;

    }, error=>{
      this.sending = false;
      (error.error == 'notfound') ? alert('Cet adresse email n\'existe pas') : alert('Une erreur s\'est occurée, veuillez réessayer');

    });
  }

  ChangePass(){
    this.sending = true;
    this.httpservice.vcChangePassExec(this.data).subscribe(v=>{
      this.sending = false;
      this.int = 3;

    }, error=>{
      this.sending = false;
      (error.error == 'notfound') ? alert('Le code que vous avez entré n\'est pas valide') : alert('Une erreur s\'est occurée, veuillez réessayer');

    });
  }

}
